if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.product__tabs-tab'));
        this.panels = Array.from(this.querySelectorAll('.product__tabs-panel'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick.bind(this));
        });
      }

      onTabClick(event) {
        const selectedTab = event.currentTarget;
        const targetId = selectedTab.dataset.tabTarget;

        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', isSelected);
        });

        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.id === targetId);
        });
      }
    }
  );
}
